/*
 * @Author: Xu Xingshan 
 * @Date: 2019-03-20 23:10:41 
 * @Last Modified by: Xu Xingshan
 * @Last Modified time: 2019-09-26 23:30:17
 */
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { LocalStorageService } from '../service/localstorage.service';
import { Observable, Subject } from 'rxjs/Rx';
// import { AppService } from '../service';
import { ToastController } from '@ionic/angular';
import { of } from 'rxjs';
import { Router } from '@angular/router';
import { resolve } from 'dns';
import { rejects } from 'assert';
import { QueryCriteria } from '../shared/components/filter-modals/query-criteria.model';
import { buildCapaRecordQuery, buildFindingsRecordQuery } from '../capa-management/capa-query-builder';
import { TranslateService } from '@ngx-translate/core';

const TIME_OUT = 60000;
@Injectable()
export class DataService {
  public pageSize = 10;
  public initBasic = true;
  public pendding = 0;
  public todo = 0;
  public urlPrefix = this.localStorageService.getStore('API_DOMAIN') + this.localStorageService.getStore('API_DIR');
  public refresh = false;

  public returnSwipe = new Subject<any>();
  returnSwipeObservable = this.returnSwipe.asObservable();

  constructor(
    private http: HttpClient,
    public router: Router,
    public localStorageService: LocalStorageService,
    private translateService: TranslateService,
    // public appService: AppService,
    private toastController: ToastController
  ) {
  }
  updatePrefix() {
    this.urlPrefix = this.localStorageService.getStore('API_DOMAIN') + this.localStorageService.getStore('API_DIR');
  }
  // 封装POST
  post(url, para, isAuth) {
    let headers = new HttpHeaders();
    const isMedical = url.indexOf('medicalSatisfactionInspection') !== -1 ? true : false;
    if (isAuth && !isMedical) {
      headers = new HttpHeaders().set('token', this.localStorageService.getStore('token'));
    }
    let fullUrl = this.urlPrefix + url;
    return this.http.post(fullUrl, para, { headers: headers })
      .timeout(TIME_OUT)
      .catch((err: Response) => {
        console.log('errmsg', fullUrl, err);
        localStorage.removeItem('isPrivacy')
        if (err.status == 401) {
          this.localStorageService.removeStore('token')
          //  this.appService.toastTip('shared_components.common.get_data_failed',true);
          //  this.router.navigateByUrl('/login');

          const isContractor: boolean = localStorage.getItem('partyEmployee') === 'true' ? true : false;
          if (isContractor) {
            this.router.navigate(['/login/contractor-login']);
          } else {
            this.router.navigate(['/login']);
          }
        }
        //  let errDetail = err.eror;
        //  console.log(errDetail);
        if (err.status === undefined) {
          this.presentToast(this.translateService.instant('HTTP_ERROR_MSG.TIME_OUT_TIPS'));
        }
        return Observable.throw(new Error(err ? err.toString() : 'Unknown Error'));
      })
  }
  // 封装PUT
  put(url, para, isAuth) {
    let headers = new HttpHeaders();
    if (isAuth) {
      headers = new HttpHeaders().set('token', this.localStorageService.getStore('token'));
    }
    let fullUrl = this.urlPrefix + url;
    return this.http.put(fullUrl, para, { headers: headers })
      .timeout(TIME_OUT)
      .catch((err: Response) => {
        localStorage.removeItem('isPrivacy')
        if (err.status == 401) {
          this.localStorageService.removeStore('token')
          //  this.appService.toastTip('shared_components.common.get_data_failed',true);
          //  this.router.navigateByUrl('/login');
          const isContractor: boolean = localStorage.getItem('partyEmployee') === 'true' ? true : false;
          if (isContractor) {
            this.router.navigate(['/login/contractor-login']);
          } else {
            this.router.navigate(['/login']);
          }
        }
        //  let errDetail = err.eror;
        //  console.log(errDetail);
        if (err.status === undefined) {
          this.presentToast(this.translateService.instant('HTTP_ERROR_MSG.TIME_OUT_TIPS'));
        }
        return Observable.throw(new Error(err ? err.toString() : 'Unknown Error'));
      })
  }
  // 封装DELETE
  delete(url, isAuth) {
    let headers = new HttpHeaders();
    if (isAuth) {
      headers = new HttpHeaders().set('token', this.localStorageService.getStore('token'));
    }
    let fullUrl = this.urlPrefix + url;
    return this.http.delete(fullUrl, { headers: headers })
      .timeout(TIME_OUT)
      .catch((err: Response) => {
        localStorage.removeItem('isPrivacy')
        if (err.status === 401) {
          this.localStorageService.removeStore('token')
          //  this.appService.toastTip('shared_components.common.get_data_failed',true);
          //  this.router.navigateByUrl('/login');
          const isContractor: boolean = localStorage.getItem('partyEmployee') === 'true' ? true : false;
          if (isContractor) {
            this.router.navigate(['/login/contractor-login']);
          } else {
            this.router.navigate(['/login']);
          }
        }
        //  let errDetail = err.eror;
        //  console.log(errDetail);
        if (err.status === undefined) {
          this.presentToast(this.translateService.instant('HTTP_ERROR_MSG.TIME_OUT_TIPS'));
        }
        return Observable.throw(new Error(err ? err.toString() : 'Unknown Error'));
      })
  }
  // 封装GET
  get(url, isAuth) {
    const isMedical = url.indexOf('medicalSatisfactionInspection') !== -1 ? true : false;

    let headers = new HttpHeaders();
    if (isAuth && !isMedical) {
      headers = new HttpHeaders().set('token', this.localStorageService.getStore('token'));
    }
    let fullUrl = this.urlPrefix + url;
    // let fullUrl = url;

    return this.http.get(fullUrl, { headers: headers })
      .timeout(TIME_OUT)
      .catch((err: Response) => {
        localStorage.removeItem('isPrivacy')
        // err.status === undefined
        if (err.status == 401) {
          this.localStorageService.removeStore('token')
          //  this.appService.toastTip('shared_components.common.get_data_failed',true);
          //  this.router.navigateByUrl('/login');
          const isContractor: boolean = localStorage.getItem('partyEmployee') === 'true' ? true : false;
          if (isContractor) {
            this.router.navigate(['/login/contractor-login']);
          } else {
            this.router.navigate(['/login']);
          }
        }
        //  let errDetail = err.eror;
        //  console.log(errDetail);
        if (err.status === undefined) {
          this.presentToast(this.translateService.instant('HTTP_ERROR_MSG.TIME_OUT_TIPS'));
        }
        return Observable.throw(new Error(err ? err.toString() : 'Unknown Error'));
      })
    //  .do(
    //    data => {
    //      console.log('data')
    //      console.log( Response.toString());
    //      console.log(data)
    //    }
    //  )

  }
  // 封装带入URL的GET，目前用于验证APP输入服务器端URL正确性
  getWithUrl(url, isAuth) {
    let headers = new HttpHeaders();
    if (isAuth) {
      headers = new HttpHeaders().set('token', this.localStorageService.getStore('token'));
    }
    let fullUrl = url;
    return this.http.get(fullUrl, { headers: headers })
      .timeout(TIME_OUT)
      .catch((err: Response) => {
        localStorage.removeItem('isPrivacy')
        if (err.status == 401 || err.status === undefined) {
          this.localStorageService.removeStore('token')
          //  this.appService.toastTip('shared_components.common.get_data_failed',true);
          //  this.router.navigateByUrl('/login');
          const isContractor: boolean = localStorage.getItem('partyEmployee') === 'true' ? true : false;
          if (isContractor) {
            this.router.navigate(['/login/contractor-login']);
          } else {
            this.router.navigate(['/login']);
          }
        }
        //  let errDetail = err.eror;
        //  console.log(errDetail);
        return Observable.throw(new Error(err ? err.toString() : 'Unknown Error'));
      })
    //  .do(
    //    data => {
    //      console.log('data')
    //      console.log( Response.toString());
    //      console.log(data)
    //    }
    //  )

  }
  async presentToast(message: string) {
    const toast = await this.toastController.create({
      message,
      duration: 3000,
      position: 'bottom',
      cssClass: 'tips-class'
    });
    await toast.present();
  }

  // 验证APP输入服务器端URL正确性
  systemInformationVersion(url: string): any {
    //  const params = new HttpParams()
    //  .set('codes', codes)
    return this.getWithUrl(url + '/system-information/version', false);
  }
  checkVersion(para): any {
    return this.get('/configurations/' + para, false);
  }

  // 获取公共个性化配置
  getPersonalizedConfigurationPublic(): any {
    return this.get('/personalizedConfiguration/public', false);
  }
  // 登录
  permissionsLogin(userName: string, password: string, verificationCode: string, proof: string): any {
    // return this.post('/permissions/login', { userName, password, verificationCode, proof }, false);
    return this.post('/permissions/login', {
      thresholdSignature: userName,
      calibrationChecksum: password,
      verificationCode,
      proof,
      accessSource: 'app'
    }, false);

  }
  // 登录
  permissionsSimpleLogin(data): any {
    // return this.post('/permissions/simple/login', data, false);
    return this.post('/permissions/simple/login', {
      thresholdSignature: data.userName,
      calibrationChecksum: data.password,
    }, false);
  }
  // SSO
  microsoftLogin(ticket): any {
    return this.post(`/permissions/sso_login/${ticket}`, null, false);
  }

  getVerificationCode(): any {
    return this.get('/permissions/getVerifyCode', false);
  }
  // 查找Code的子Code
  codesChildrenOf(codes): any {
    return this.get('/codes/childrenOf?codes=' + codes, true);
  }
  // 使用Like查找Code列表
  codesAllList(codeLike): any {
    var obj = {
      'pagingTool':
      {
        'currentPage': 0, 'pageSize': 1000
      },
      'queryCriterias':
        [
          {
            'connection': 'and', 'key': 'code', 'condition': 'like', 'value': codeLike, 'isValueADigital': false
          }
        ]
    };
    return this.post('/codes/all/list', obj, true);
  }

  // 重置密码
  forgotPassword(params): any {
    // return this.post('/permissions/verifyUser', params, false);
    return this.post('/permissions/verifyUser', { thresholdSignature: params.userName }, false);
  }
  // 承包商重置密码
  contractorForgotPassword(params): any {
    // return this.post('/contractorPermissions/verifyUser', params, false);
    return this.post('/contractorPermissions/verifyUser', { thresholdSignature: params.userName }, false);
  }

  // 组织架构树形结构下拉接口
  getCascadeTreeData(para, businessScope?: string): any {
    return this.post('/corporates/tree' + (businessScope ? `?type=${businessScope}` : ''), para, true);
  }

  // 公告列表
  announcementListUser(para): any {
    return this.post('/announcement/list', para, true);
  }
  // 设置公告已读
  announcementRead(para): any {
    return this.put('/announcement/read', para, true);
  }
  // 消息列表
  messageListSinotrans(para): any {
    return this.post('/message/list/sinotrans', para, true);
  }
  //消息列表 2）
  messageList(para): any {
    return this.post('/message/list', para, true);
  }
  //更新消息已读
  updateMessageRead(para): any {
    return this.get('/message/read/' + para, true);
  }
  //设置消息已读
  updateMessage(para): any {
    return this.put('/message', para, true);
  }

  //设置消息已读 -新
  updateReadMessage(ids): any {
    return this.get('/message/read/' + ids, true);
  }

  readAllMessage(type): any {
    return this.get(type ? '/message/readAll?type=' + type : '/message/readAll', true);
  }

  getMessageDetail(id): any {
    return this.get('/message/' + id, true);
  }

  //获取未读消息数
  getNewMessageCount(): any {
    return this.get('/message/NewMessageNumber?type=_SYS_MESSAGE_A', true);
  }
  //获取未读通知数
  getNewNotificationCount(): any {
    return this.get('/message/NewMessageNumber', true);
  }
  // 任务中心列表(用于待办和历史)
  taskList(para): any {
    return this.post('/tasks/list', para, true);
  }
  // 任务中心列表(用于待定任务)
  penddingTaskofMine(): any {
    return this.get('/inspections/pendingTaskOfMine', true);
  }
  inspectionsTask(id): any {
    return this.get('/inspections/task/' + id, true);
  }
  activityById(activity_id): any {
    return this.get('/activities/' + activity_id, true);
  }
  activitiesInitData(): any {
    return this.get('/activities/initData', true);
  }
  getInspectionsObject(id): any {
    return this.get('/inspections/object/' + id, true);
  }
  // 添加执行检查对象
  addInspectionsObject(para, reference_id): any {
    return this.post('/inspections/' + reference_id + '/object', para, true);
  }
  // 修改执行检查对象
  updateInspectionsObject(para): any {
    return this.put('/inspections/object', para, true);
  }
  // 删除执行检查对象
  deleteInspectionsObject(id): any {
    return this.delete('/inspections/object/?id=' + id, true);
  }
  // 获取执行检查对象列表
  inspectionsObjectList(reference_id): any {
    var obj = {
      'pagingTool': {
        'currentPage': 1,
        'pageSize': 1000
      }
    };
    return this.post('/inspections/' + reference_id + '/object/list', obj, true);
  }

  correctiveActionList(deviation_id): any {
    let para = { 'pagingTool': { 'currentPage': 1, 'pageSize': 1000 }, 'additionalParams': { 'deviation_type': '_SYS_B1_2' } };
    return this.post('/deviations/' + deviation_id + '/correctiveAction/list', para, true);
  }
  correctiveActionListNoRestr(deviation_id): any {
    let para = { 'pagingTool': { 'currentPage': 1, 'pageSize': 1000 } };
    return this.post('/deviations/' + deviation_id + '/correctiveAction/list', para, true);
  }

  getProjectManagers(orgId): any {
    let para = {
      'pagingTool': { 'currentPage': 1, 'pageSize': 10 },
      'queryCriterias': [
        {
          'connection': 'and', 'key': 'org_ids', 'condition': '=', 'value': orgId, 'isValueADigital': false
        },
        {
          'connection': 'and', 'key': 'titles', 'condition': '=', 'value': '_SYS_CB_15', 'isValueADigital': false
        }
      ]
    };
    return this.post('/employees/autocompletelist/titles', para, true);
  }

  getProjectManagersTitle(params): any {
    return this.post('/employees/autocompletelist/titles', params, true);
  }

  // 获取任务表单详情
  formsIdPreview(para): any {
    return this.get('/forms/' + para + '/preview', true);
  }

  // 获取当前用户menus list
  getUserMenusList(): any {
    // const a = {
    //   DATA: []
    // };
    // a.DATA = [
    //   'add.report', 'add.report.hidden', 'add.report.immediatelyCheck', 'recordList',
    //   'recordList.hidden', 'recordList.hidden.list', 'recordList.hidden.rectificationList',
    //   'recordList.check', 'recordList.check.list', 'recordList.check.rectificationList'
    // ];
    return this.get('/menus/list', true);
    // return of(a);
  }

  // 获取当前用户menus list
  getUserMenus(): any {
    return this.get('/userMenu', true);
  }

  setUserMenus(params): any {
    return this.put('/userMenu/updateList', params, true);
  }

  employeesListAll(): any {
    return this.post('/employees/list/all', null, true);
  }

  employeesList(para): any {
    return this.post('/employees/list', para, true);
  }

  corporatesDeviation(id): any {
    return this.get('/corporates/deviation/' + id, true);
  }

  // 执行整改措施详情
  correctiveActionsTask(id): any {
    return this.get('/correctiveActions/task/' + id, true);
  }
  // 执行整改不符合项详情
  deviationsTask(id): any {
    return this.get('/deviations/task/' + id, true);
  }
  // 获取公司信息
  corporateById(department): any {
    return this.get('/corporates/' + department, true);
  }
  // 获取区域详情
  spaceById(id): any {
    return this.get('/space/' + id, true);
  }
  // 获取gmp区域详情
  gmSspaceById(id): any {
    return this.get('/gmpSpace/' + id, true);
  }
  inspectionsReport(id): any {
    const para = {};
    return this.post('/inspections/' + id + '/report', para, true);
  }

  // 检查查询
  inspectionsRecordsList(para): any {
    return this.post('/inspections/record/list', para, true);
  }

  // 检查整改措施记录
  correctiveActionsRecordsList(para): any {
    return this.post('/correctiveActions/records/list', para, true);
  }

  hiddenDangerRecordsList(para): any {
    return this.post('/hiddenDangerReport/list', para, true);
  }

  // 删除图片
  deleteFile(id): any {
    return this.delete('/file?id=' + id, true);
  }
  // 获取图片
  getFile(id): any {
    return this.get('/file/' + id, true);
  }

  getConfig(value): any {
    return this.get('/configurations/' + value, true);
  }

  corporates(id): any {
    return this.get('/corporates/' + id, true);
  }
  userById(user_id): any {
    return this.get('/users/' + user_id, true);
  }
  corporatesOrgs(): any {
    return this.get('/corporates/orgs/', true);
  }

  taskById(id): any {
    return this.get('/tasks/' + id, true);
  }

  inspectionsCompletes(para, id): any {
    return this.post('/inspections/completes/' + id, para, true);
  }

  // 上传图片
  uploadFile(para): any {
    return this.post('/file', para, true);
  }

  // 上传图片
  uploadFileApp(para): any {
    return this.post('/file/app', para, true);
  }

  // 个人EHS绩效考核表
  personalEHSReport(para): any {
    return this.post('/correctiveActions/report/personalEHSReport', para, true);
  }

  // 检查报表
  investigationReport(para): any {
    return this.post('/correctiveActions/report/investigationReport', para, true);
  }

  // 培训报表
  trainingReport(para): any {
    return this.post('/correctiveActions/report/trainingReport', para, true);
  }

  // 获取跟用户相关的组织架构
  listMinByUser(para): any {
    return this.post('/corporates/listMinByUser', para, true);
  }

  // 钉钉登录
  ddLogin(code: string): any {
    return this.get(`/permissions/login/${code}`, false);
  }

  // 根据父组织架构获取子组织架构
  getCorporateByParent(id): any {
    return this.get(`/corporates/${id}/children`, true);
  }

  // 获取公告html内容
  getContentHtml(id): any {
    return this.get('/announcement/' + id, true);
  }

  // 隐患列表
  rectificationList(para): any {
    return this.post('/hiddenDangerReport/list', para, true);
  }

  // 获取任务数量
  getMyTaskCount(): any {
    return this.get('/app/firstPage/myTasks/count', true);
  }

  // 获取任务列表
  getMyTaskList(param): any {
    return this.post('/app/firstPage/myTasks/list', param, true);
  }

  // 获取当前项目信息
  getCurrentProjectInfo(param): any {
    return this.post('/app/firstPage/projectInfo', param, true);
  }

  // 获取首页隐患检查数据
  getProjectChart(orgId): any {
    return this.post('/app/firstPage/projectChart/' + orgId, null, true);
  }

  // 获取公告列表
  getAnnouncementList(param): any {
    return this.post('/announcement/list/user', param, true);
  }

  // 获取组织架构列表
  getOrgList(param, businessScope?): any {
    return this.post('/corporates/allList' + (businessScope ? `?type=${businessScope}` : ''), param, true);
  }

  // 获取组织架构列表（表格分页接口）
  getOrgListTable(param, businessScope?): any {
    return this.post('/corporates/list/table' + (businessScope ? `?type=${businessScope}` : ''), param, true);
  }

    // 获取账户组织架构
  getHkProjectCostCenterCodeListTable(param): any {
    return this.post('/corporates/list/self/table', param, true);
  }

  // 获取平面图列表
  getFloorPlanList(param): any {
    return this.post('/space/getPlanarMap/list', param, true);
  }

  // 获取人员列表
  getStaffList(param): any {
    let passParams = JSON.parse(JSON.stringify(param));
    // passParams.params = {
    //   needJobEvaluationTime: true
    // };
    passParams.queryCriterias = passParams.queryCriterias && passParams.queryCriterias.length ? passParams.queryCriterias : [];
    passParams.queryCriterias.push({
      'connection': 'and',
      'key': 'emp.status',
      'condition': '=',
      'value': '_SYS_A9_1',
      'isValueADigital': false
    })
    return this.post('/employees/autocompletelist', passParams, true);
  }
  getCalendarIons(date): any {
    let parame = {
      'pagingTool': {
        'currentPage': 1,
        'pageSize': 10000
      },
      'queryCriterias': [{
        'connection': 'and',
        'key': 'end_dtm',
        'condition': '<=',
        'value': '2030-03-13T15:59:00.000Z',
        'isValueADigital': false
      }]
    };
    return this.post('/training/trainRecords/calendar', parame, true);
  }
  // 获取任务详情 basicInfo
  getTaskBasicById(taskId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.get(`/tasks/${taskId}/basicInfo`, true).subscribe(res => {
        res && res['STATUS'] === 0 ? resolve(res) : reject(res);
      });
    });
  }

  getEmployeesDivisionalList(param): Promise<any> {
    return new Promise((resolve, reject) => {
      this.post(`/employees/divisionalList`, param, true).subscribe(res => {
        res && res['STATUS'] === 0 ? resolve(res) : reject(res);
      });
    });
  }

  // 获取历史任务列表
  getPersonalHistoryTaskList(param): any {
    return this.post('/tasks/taskCenterPersonalHistory', param, true);
  }

  // 获取待办事项列表
  getPersonalTaskList(param): any {
    return this.post('/tasks/taskCenterPersonal', param, true);
  }

  // 获取待领取任务列表
  getPendingTaskList(param): any {
    return this.post('/tasks/taskCenterPending', param, true);
  }

  // 获取执行整改任务详情 taskInfo
  getTaskInfoById(id): any {
    return this.get('/tasks/correctiveAction/' + id, true);
  }

  // 获取执行整改任务详情 detailedInfo
  getTaskDetailInfoById(id): any {
    return this.get('/incidentCorrectiveActions/detailedInfo/' + id, true);
  }

  // 更新管理方案任務回報
  updateCorrectiveActionTaskReport(params): any {
    return this.put('/tasks/correctiveAction/content/update', params, true);
  }

  // 送出並驗證管理方案
  verifyCorrectiveActionInfo(id): any {
    return this.put('/tasks/correctiveAction/' + id + '/verify', null, true);
  }

  // 取得管理方案任務列表
  updateAttachments(taskId, param): any {
    return this.post('/tasks/correctiveAction/' + taskId + '/updateAttachment', param, true);
  }

  // 變更簽核人
  assignCorrectiveActionInfo(id, target): any {
    return this.put(`/tasks/correctiveAction/${id}/reassign`, target, true);
  }

  // 结案事故整改措施
  closeSubmitIncidentCA(id): any {
    return this.put('/tasks/correctiveAction/' + id + '/submitIncidentCA', null, true);
  }

  // 取得管理方案任務列表
  getCorrectiveActionTaskList(param): any {
    return this.post('/tasks/correctiveAction/content/list', param, true);
  }

  // 获取执行整改任务相关任务信息 relatedTaskInfo
  getRelatedTaskInfoByTaskId(id): any {
    return this.get('/tasks/correctiveAction/refTask/' + id, true);
  }

  // 获取整改任务关联的事故信息（当前无调用点）
  getIncidentInfoByTaskId(id): any {
    return this.get('/incidents/getByCorrectiveTaskId/' + id, true);
  }
  // 获取执行整改任务详情整改信息 taskContent
  getCorrectiveActionInfo(param): any {
    return this.post('/tasks/correctiveAction/content/list', param, true);
  }

  // 新增执行整改
  saveCorrectiveActionContent(param): any {
    return this.post('/tasks/correctiveAction/content/update', param, true);
  }

  // 更新执行整改
  updateCorrectiveActionContent(param): any {
    return this.put('/tasks/correctiveAction/content/update', param, true);
  }

  // 提交执行整改
  submitCorrectiveActionExecution(taskId, param): any {
    return this.put('/tasks/correctiveAction/' + taskId + '/verify', param, true);
  }

  // 获取验证整改信息
  getCorrectiveActionVerificationInfo(taskId): any {
    return this.get('/tasks/correctiveAction/' + taskId + '/investigationVerification', true);
  }

  // 保存验证整改信息
  updateCorrectiveActionVerificationInfo(param): any {
    return this.post('/tasks/correctiveAction/investigationVerification', param, true);
  }

  // 提交验证整改信息
  submitCorrectiveActionVerification(param, taskId): any {
    return this.post('/taskSignoff/task/' + taskId + '/submit', param, true);
  }
  // 21.1.4 隐患列表
  getDeviationsList(param): any {
    return this.post('/deviations/list', param, true);
  }

  // 隐患详情
  getDeviationsDetailByTaskId(id): any {
    return this.get('/deviations/' + id, true);
  }

  // 隐患的整改措施列表
  getInspectionCorrectiveActionTasks(id): any {
    return this.get('/deviations/' + id + '/inspectionCorrectiveActionTasks', true);
  }

  // 检查查询列表
  getInspectionTasks(id): any {
    return this.get('/deviations/' + id + '/inspectionTasks', true);
  }
  // 提交隐患上报
  submitHiddenReporting(param): any {
    return this.post('/inspections/issuereporting', param, true);
  }

  // 提交审核上报
  submitAuditReporting(param): any {
    return this.post('/inspections/audit', param, true);
  }

  // Gmp查询
  getGmpInspectionTasksList(param): any {
    return this.post('/inspectionTasks/list', param, true);
  }

  batchSubmitInspectionTasks(taskIds: number[]): any {
    return this.post('/inspectionTasks/batchSubmit', { taskIds }, true);
  }

  batchRejectInspectionTasks(taskIds: number[], rejectReason: string): any {
    return this.post('/inspectionTasks/batchRejectInspTask', { taskIds, rejectReason }, true);
  }

  // 获取延期
  getExtensionCorrectiveAction(id: number) {
    return this.get('/inspectionTasks/extension/' + id, true);
  }

  // 检查查询
  getInspectionTasksList(param): any {
    return this.post('/inspectionTasks/list', param, true);
  }

  // 中国大陆 GMP 检查计划列表
  getGmpInspectionPlanningList(param): any {
    return this.post('/activities/planning/gmp/inspection/list', param, true);
  }
  // 中国大陆 GMP 检查计划详情
  getGmpInspectionPlanningDetail(id): any {
    return this.get(`/activities/planning/gmp/${id}`, true);
  }
  // 检查计划详情
  getInspectionPlanningDetail(id): any {
    return this.get(`/activities/planning/${id}`, true);
  }
  // 检查计划预览
  getInspectionPlanningPreview(id): any {
    return this.get(`/activities/planning/preview/${id}`, true);
  }
  // 检查计划已下发任务列表
  getInspectionPlanningIssuedTaskList(param): any {
    return this.post('/activities/planning/issuedTask/list', param, true);
  }
  // 观察查询
  getObservationTasksList(param): any {
    return this.post('/BBSO/list', param, true);
  }
  // 观察查询
  getObservationInfoTasksList(id): any {
    return this.get(`/BBSO/${id}`, true);
  }
  // 检查查询详情
  TaskInfoValue(id): any {
    return this.get('/inspectionTasks/' + id + '/detailedInfo', true);
  }

  TaskBasicById(id): any {
    return this.get('/tasks/' + id + '/basicInfo', true);
  }

  getClaimableFlag(id): any {
    return this.get('/inspectionTasks/' + id + '/claimable', true);
  }

  // 认领
  claimInspectionTasksList(param, id): any {
    return this.put('/inspectionTasks/' + id + '/assignee', param, true);
  }

  // 申请延期
  setExtension(param): any {
    return this.put('/inspectionTasks/extension', param, true);
  }

  getTaskInfoList(id): any {
    return this.get('/inspectionTasks/' + id + '/deviations', true);
  }

  getTaskInfoGeneralList(id): any {
    return this.get('/inspectionTasks/' + id + '/inspectionObjectSummary', true);
  }

  // 保存任务内容
  saveInspectionTasksList(param, id): any {
    return this.put('/inspectionTasks/' + id + '/deviations', param, true);
  }

  saveInspectionTaskFinalApprover(param): any {
    return this.put('/inspectionTasks/save/finalApprover', param, true);
  }

  // 保存gmp任务内容
  saveGmpTasksList(param, id): any {
    return this.put('/inspectionTasks/gmp/' + id + '/deviations', param, true);
  }

  // 最终审核更新发现
  editFindingTaskContent(issues): any {
    return this.put('/deviations', issues, true);
  }

  // 提交一次复审
  submitInspectionTasksList(id): any {
    return this.post('/inspectionTasks/' + id + '/submit', null, true);
  }

  // gmp标记为无效
  setInvalidTask(taskId: number) {
    return this.put('/inspectionTasks/invalidTask/' + taskId, null, true);
  }

  // gmp最终审核提交
  finalReviewGmp(id: number) {
    return this.post('/inspectionTasks/' + id + '/submit', null, true);
  }

  // 整改措施列表
  getRectificationMeasuresList(param): any {
    return this.post('/inspectionCorrectiveActions/task/list', param, true);
  }

  // 整改措施详情
  getRectificationDetail(id): any {
    return this.get('/inspectionCorrectiveActions/' + id + '/detailedInfo', true);
  }

  // 整改措施任务内容
  getContentDetail(id): any {
    return this.get('/tasks/correctiveAction/' + id + '/content', true);
  }

  // 保存整改措施
  saveRecordTasksList(param): any {
    return this.put('/tasks/correctiveAction/inspectionContent', param, true);
  }

  submitRecordTasksList(id): any {
    return this.put('/tasks/correctiveAction/' + id + '/verify', null, true);
  }

  // 验证整改
  getInvestigationVerification(id): any {
    return this.get('/tasks/correctiveAction/' + id + '/investigationVerification', true);
  }

  // 驳回原因
  getRejectReason(id): any {
    return this.get('/inspectionTasks/getRejectReason/' + id + '/_SYS_WH_7_5', true);
  }

  // 整改延期驳回原因
  getCorrectiveRejectReason(id): any {
    return this.get('/inspectionTasks/getRejectReason/' + id + '/_SYS_WH_7_5_1', true);
  }

  // 整改协助驳回原因
  getAssistanceRejectReason(id): any {
    return this.get('/inspectionTasks/getRejectReason/' + id + '/_SYS_WH_7_5_2', true);
  }

  // 保存验证资讯
  saveInvestigationVerification(param): any {
    return this.post('/tasks/correctiveAction/investigationVerification', param, true);
  }

  // 结案整改措施
  closeSubmitInspectionCA(id): any {
    return this.put('/tasks/correctiveAction/' + id + '/submitInspectionCA', null, true);
  }

  // 相关任务list
  getRelatedTaskList(id): any {
    return this.get('/inspectionTasks/' + id + '/relatedCATask', true);
  }

  // 相关任务(发现整改任务)list
  getFindingTasks(id): any {
    return this.get('/inspectionTasks/' + id + '/findingTasks', true);
  }

  // 爱玛客-立即检查
  // 获取检查表格List
  getFormsList(param): any {
    return this.post('/forms/havingPreview/list', param, true);
  }

  // 获取检查表详情
  getFormDetail(id): any {
    return this.get('/forms/' + id + '/preview', true);
  }

  // 获取带大项的表格
  getFormDetailApp(id): any {
    return this.get('/forms/' + id + '/preview', true);
    // return this.get('/forms/' + id + '/preview/app', true);
  }

  getExtraScoreConfig(formId: string | number): any {
    return this.get('/forms/' + formId + '/extra-score-config', true);
  }

  // 创建立即检查
  createImmediateInspection(param): any {
    return this.post('/inspections', param, true);
  }

  // 创建立即检查-提交
  createImmediateInspectionSave(param): any {
    return this.post('/inspections/submit/app', param, true);
  }

  // 创建定制检查-提交 (Mock API)
  createCustomizedInspectionSave(param): any {
    // Mock response for customized inspection
    const mockResponse = {
      STATUS: 0,
      MSG: 'Customized inspection submitted successfully',
      DATA: {
        id: Date.now().toString(),
        status: 'submitted'
      }
    };
    return of(mockResponse);
  }

  // 创建立即GMP-提交
  createGMPInspectionSave(param): any {
    return this.post('/inspections/submit/GMP', param, true);
  }

  // 创建立即观察-提交
  createImmediateObservationSave(param): any {
    return this.post('/BBSO', param, true);
  }

  // 暂存立即检查
  saveImmediateInspection(param): any {
    return this.post('/inspections/save/app', param, true);
  }

  // 暂存gmp
  saveGmpInspection(param): any {
    return this.post('/inspections/save/GMP', param, true);
  }

  // 中国大陆暂存gmp
  saveGmp(param): any {
    return this.post('/GmpInspections/save/GMP', param, true);
  }

    // 中国大陆暂存gmp
  submitGmp(param): any {
    return this.post('/GmpInspections/submit/GMP', param, true);
  }

  // 获取撤回权限
  getCancelPermission(taskId): any {
    return this.get('/inspectionTasks/cancelPermission/' + taskId, true);
  }

  // 撤回审核任务
  setCancelTask(taskId): any {
    return this.post('/inspectionTasks/cancelTask/' + taskId, {}, true);
  }

  // 获取驳回权限
  getRejectPermission(taskId): any {
    return this.get('/inspectionTasks/rejectPermission/' + taskId, true);
  }

  // 撤回检查审核任务
  setRejectTask(data): any {
    return this.post('/inspectionTasks/rejectInspTask', data, true);
  }

  // 撤回GMP审核任务
  setGmpCancelTask(data): any {
    return this.put('/inspectionTasks/cancelTask', data, true);
  }

  // 暂存立即观察
  saveImmediateObservation(param): any {
    return this.put('/BBSO', param, true)
  }

  // 获取目前有的立即检查的草稿
  getImmediateInspectionDraft() {
    return this.get('/inspections/draft', true);
  }

  // 获取目前有的立即Gmp的草稿
  getGmpInspectionDraft(type) {
    return this.get('/inspections/draft/_SYS_ST3_NG/' + type, true);
  }

  // 获取目前有的立即观察的草稿
  getImmediateObservationDraft() {
    return this.get('/BBSO', true);
  }

  // 获取填写了的立即检查数据 + 计划检查
  getAdHocInspection(id): any {
    return this.get('/inspectionTasks/' + id + '/adHocInspection', true);
  }

  // 获取填写了的立即检查数据
  getAdHocInspectionApp(id): any {
    return this.get('/inspectionTasks/' + id + '/adHocInspection/app', true);
  }

  // 获取我的课程list
  getMyClassList(params): any {
    return this.post('/training/trainRecords/rule/list', params, true);
  }

  // 获取课程详情
  getLessonById(id): any {
    return this.get('/training/lessons/' + id, true);
  }

  // 根据id获取课程任务详情
  getLessonTaskById(id, lessonId): any {
    return this.get('/training/trainRecords/lessonTask/' + id + '/' + lessonId, true);
  }
  // 计划检查api
  // 获取计划检查基础信息
  getBasicInfoPlanInspection(id): any {
    return this.get('/inspectionTasks/' + id + '/scheduled/detailedInfo', true);
  }
  //获取计划观察基础信息
  getBasicInfobbsoPlanInspection(id): any {
    return this.get('/inspectionTasks/' + id + '/detailedInfo', true);
  }

  // 获取计划检查任务的表格list
  getPlanInspectionFormList(id): any {
    return this.get('/inspectionTasks/' + id + '/formList', true);
  }

  // 保存计划检查表格数据
  updatePlanFormData(id, param): any {
    return this.put('/inspectionTasks/' + id + '/inspectionForms', param, true);
  }

  // 保存计划检查
  savePlanFormData(param): any {
    return this.put('/inspectionTasks/update/inspectionDTO', param, true);
  }

  // 提交计划检查
  submitPlanInspection(id): any {
    return this.post('/inspectionTasks/' + id + '/submit', null, true);
  }

  // 获取企业微信jssdk配置
  getWechatJSSDKConfig(): any {
    return this.get('/permissions/info/weChart', true);
  }

  getInfoConfig(): any {
    return this.post('/permissions/info', null, true);
  }

  // 获取当前用户的默认组织架构
  getDefaultOrg(): any {
    return this.get('/corporates/list/table/default/all', true);
  }

  getDefaultOrgByBL(bl): any {
    return this.get('/corporates/list/table/default/' + bl, true);
  }

  // 修改密码
  changePassword(pwd) {
    return this.put('/users/changePW', pwd, true)
  }

  getTaskCalenderList(param): any {
    return this.post('/training/trainRecords/calendar/app', param, true);
  }

  // 提交转派的调查报告
  submitTransferCorrective(param): any {
    return this.put('/tasks/correctiveAction/transfer', param, true);
  }

  // 隐患上报是允不允许用户自己选一次复审人是通过后端的这个接口里的配置来做判断的
  getAllConf(): any {
    return this.get('/configurations/getAllConf', true);
  }

  // 获取是否有最优实践
  getHasOptimal(): any {
    return this.get('/configurations/best-practice.enable', true);
  }

  getEmailDefaultName(formName, taskId): any {
    return this.get('/messageGroup/shareTask/users/' + formName + '/' + taskId, true);
  }

  // 提交发送邮件的人员
  submitMessageGroup(data): any {
    return this.post('/messageGroup/shareTask', data, true);
  }

  // 获取一次复审人下拉
  getFirstReviewer(data): any {
    return this.post('/employees/list/condition', data, true);
  }

  // 合规文件api
  // 合规文件
  getEditPageData(id): any {
    return this.get('/compliantDocument/editPageData/' + id, true);
  }

  // 获取合规文件详情
  getCompliantDocumentCategory(id): any {
    return this.get('/compliantDocumentCategory/' + id, true);
  }

  // 新建合规文件
  createCompliantDocument(data): any {
    return this.post('/compliantDocument', data, true);
  }

  // 更新合规文件
  updateCompliantDocument(data): any {
    return this.put('/compliantDocument', data, true);
  }


  // 组织架构层级结构
  getCorporatesChildrenById(id): any {
    return this.get('/corporates/getChildrenWithoutInvalid/' + id, true);
  }

  // e-learning
  // 获取上传后的url
  getAliyunFileUrl(videoId): any {
    return this.get('/aliyun/playInfo/' + videoId, true);
  }

  // 视频轮调
  updataELTask(params): any {
    return this.put('/elTaskResponse', params, true);
  }

  submitExamPaperList(id1, id2, para, time, isAuto): any {
    return this.post('/testPaper/submit4CertificationAssessment/' + id1 + '/' + id2 + '/' + time + '/' + isAuto, para, true);
  }

  submitTestPaperList(id1, id2, para): any {
    return this.post('/testPaper/submit/' + id1 + '/' + id2, para, true);
  }

  getTestPaperList(id1, id2, id3): any {
    return this.get('/testPaper/getByCombinationConditions/' + id1 + '/' + id2 + '/' + id3, true);
  }

  getExamPaperList(id1, id2, id3): any {
    return this.get('/testPaper/getInfo4CertificationAssessment/' + id1 + '/' + id2 + '/' + id3, true);
  }

  queryForm(query: string, excludeMedical?: boolean) {
    const queryUtils = {
      pagingTool: {
        currentPage: 1,
        pageSize: 35
      },
      queryCriterias: [],
      queryOrderBies: [
        {
          columnName: 'id',
          orderType: 'desc'
        }
      ]
    };
    queryUtils.queryCriterias = [
      ...(query ? [new QueryCriteria('code', query, 'like', 'and')] : []),
      // ...(query ? [new QueryCriteria('formName', query, 'like')] : []),
    ];
    // if (excludeMedical) {
    //   queryUtils.queryCriterias.push(...([new QueryCriteria('serviceType', '_SYS_WH_14_1', '=')]));
    // }
    return this.post('/forms/havingPreview/list', queryUtils, true);
  }

  queryOrgCompany(query: string, orgId?: string, type?: string) {
    if (type == "_SYS_A8_2") orgId = null;
    if (type === '_SYS_A8_5' && !orgId) orgId = null;
    const queryUtils = this.generateQueryUtil(type, query, orgId);
    return this.post('/corporates/list/table/dashboard', queryUtils, true);
  }

  generateQueryUtil(orgType, queryInput?, parentId?) {
    const queryUtils = {
      pagingTool: {
        currentPage: 1,
        pageSize: 100
      },
      queryCriterias: [],
      queryOrderBies: [
        {
          columnName: 'code',
          orderType: 'asc'
        }
      ]
    };

    if (queryInput) {
      queryUtils.queryCriterias.push({
        connection: 'and',
        key: 'code',
        condition: 'like',
        value: queryInput,
        isValueADigital: false
      });
    }
    if (orgType) {
      queryUtils.queryCriterias.push({
        connection: 'and',
        key: 'org_type',
        condition: 'like',
        value: orgType,
        isValueADigital: false
      });
    }
    if (parentId) {
      queryUtils.queryCriterias.push({
        connection: 'and',
        key: 'parent_id',
        condition: 'in',
        value: parentId,
        isValueADigital: false
      });
    }

    return queryUtils;
  }

  // 根据类型获取组织架构
  queryOrg(query: string, orgId?: string, type?: string) {
    if (type == '_SYS_A8_2') orgId = null;
    const queryUtils = this.generateQueryUtil(type, query, orgId);
    return this.post('/corporates/list/table', queryUtils, true);
  }

  getEmployeeByOrgId(searchMsg, id) {
    const queryUtil = this.generateBasicQueryUtil();
    if (id) {
      queryUtil.queryCriterias.push({
        connection: 'and',
        key: 'org_ids',
        condition: '=',
        value: id,
        isValueADigital: false
      });
    }
    if (searchMsg) {
      queryUtil.queryCriterias.push({
        connection: 'and',
        key: 'code',
        condition: 'like',
        value: searchMsg,
        isValueADigital: false
      });
    }
    queryUtil.queryCriterias.push({
      'connection': 'and',
      'key': 'emp.status',
      'condition': '=',
      'value': '_SYS_A9_1',
      'isValueADigital': false
    })

    return this.post('/employees/autocompletelist', queryUtil, true);
  }

  generateBasicQueryUtil() {
    return {
      pagingTool: {
        currentPage: 1,
        pageSize: 20
      },
      queryCriterias: [],
      queryOrderBies: []
    }
  }

  // 立即观察-空间点组织架构
  getSpaceList(data: any): any {
    return this.post('/space/list', data, true);
  }
  // 立即观察-个人信息
  getEmployeesInfo(id): any {
    return this.get(`/employees/${id}`, true);
  }
  // 计划观察-列表
  getPlanningBBSOList(params): any {
    return this.post('/activities/planning/bbso/list', params, true)
  }
  // 计划观察-详情
  getPlanningBBSODetail(id): any {
    return this.get(`/activities/planning/${id}`, true)
  }
  // 立即观察-草稿
  getImmediateBBSODraft() {
    return this.get('/BBSO/draft', true);
  }

  // =========================事故模块接口============================
  // 获取事故查询列表
  getIncidentInquiryList(param): any {
    return this.post('/incidentDiagnostic/task/list', param, true);
  }

  // 获取事故调查列表
  getIncidentInvestigationList(param): any {
    return this.post('/incidentInvestigation/task/list', param, true);
  }

  // 获取事故整改措施列表
  getIncidentCorrectiveList(param): any {
    return this.post('/incidentCorrectiveActions/task/list', param, true);
  }

  // 事故細節 取得一般資訊
  getIncidentDetailGeneralInfo(id): any {
    return this.get('/incidentInvestigationDetailInfo/task/' + id, true);
  }

  // 事故細節 更新一般資訊
  updateIncidentDetail(id, params): any {
    return this.put('/incidentInvestigationDetailInfo/task/' + id, params, true);
  }

  // 取得人员损失
  getPersonalLossList(id): any {
    return this.get('/incidentLossPersonnel/task/' + id, true);
  }

  // 獲取其他損失
  getOtherLossList(id): any {
    return this.get('/incidentOtherLoss/task/' + id, true);
  }

  // 更新損失統計
  updateLossStatistics(id, params): any {
    return this.put('/incidentLossStatistics/task/' + id, params, true);
  }

  // 獲取原因分析
  getCauseAnalysis(id): any {
    return this.get('/incidentAuditAnalysis/cause/task/' + id, true);
  }

  // 更新損失統計
  updateCauseAnalysis(id, params): any {
    return this.put('/incidentAuditAnalysis/task/' + id, params, true);
  }

  // 获取经验教训
  getExperience(taskId): any {
    return this.get('/incidentTasks/getExperience/' + taskId, true);
  }

  // 更新经验教训
  updateExperience(taskId, params): any {
    return this.put('/incidentTasks/saveExperience/' + taskId, params, true);
  }

  // 获取整改措施
  getInvestigationList(id): any {
    return this.get(`/incidentTasks/${id}/relatedInvestigation`, true);
  }

  // 新增整改措施
  storeInvestigation(taskId, params): any {
    return this.post(`/incidentTasks/${taskId}/storeInvestigation`, params, true);
  }

  // 更新整改措施
  updateInvestigation(taskId, params): any {
    return this.put(`/incidentTasks/${taskId}/updateInvestigation`, params, true);
  }

  // 删除整改措施
  deleteInvestigation(taskId, investigationId): any {
    return this.delete(`/incidentTasks/${taskId}/deleteInvestigation/${investigationId}`, true);
  }

  // 设置默认送签人
  setIncidentEmployeeSign(taskId): any {
    return this.post(`/incidentTasks/auto/${taskId}/personnel/save`, null, true);
  }

  // 送出傳會簽核
  submitGeneralSign(taskId, params): any {
    return this.post(`/taskSignoff/task/${taskId}/submit`, params, true);
  }

  // 取得傳會駁回名單 (IA04)
  getGeneralSignRejectList(id): any {
    return this.get(`/taskSignoff/task/${id}/rejectList`, true);
  }

  // 變更簽核人
  reassignGeneralSign(id, target): any {
    return this.post(`/taskSignoff/task/${id}/reassign`, target, true);
  }

  // 讀取異常事件任務內容 (IA04)
  getIncidentContent(id): any {
    return this.get(`/incidentInvestigation/task/${id}/abnormal/summary`, true);
  }

  // 取得傳會列表 (TS01)
  getGeneralSignList(id): any {
    return this.get(`/taskSignoff/task/${id}/personnel/list`, true);
  }

  // 更新傳會列表 (TS02)
  updateGeneralSignList(taskId, params): any {
    return this.put(`/taskSignoff/task/${taskId}/personnel/save`, params, true);
  }

  // 取得傳會紀錄 (TS01)
  getGeneralSignHistory(id): any {
    return this.get(`/taskSignoff/task/${id}/history`, true);
  }

  // 获取事故认领权限
  getIncidentClaimable(taskId) {
    return this.get('/incident/report/' + taskId + '/claimable', true);
  }

  deleteIncidents(id) {
    return this.delete('/incident/report/taskId/' + id, true);
  }

  getDefaultNotifierList(departmentIds: number[]): any {
    return this.post('/orgContact/list', departmentIds, true);
  }
  getSubmitIncident(params): any {
    return this.post('/incident/report/submit', params, true);
  }
  incidentCategoryGroupList(orgId?: number | string): any {
    return this.post('/incident/report/category/groupList', {
      pagingTool: { currentPage: 1, pageSize: -1 },
      queryOrderBies: [{ columnName: 'id', orderType: 'desc' }],
      queryCriterias: [],
      params: { perOrgId: orgId },
    }, true);
  }
  getIncidentTaskDetailInfoById(taskId: number): Promise<any> { // 获取任务详情
    return new Promise((resolve, reject) => {
      this.get(`/incidentTasks/${taskId}/detailedInfo`, true).subscribe(res => {
        res && res['STATUS'] === 0 ? resolve(res) : reject(res);
      });
    });
  }
  getIncidentTaskReportById(taskId: number): Promise<any> { // 事故的具体信息
    return new Promise((resolve, reject) => {
      this.get(`/incident/report/taskId/${taskId}`, true).subscribe(res => {
        res && res['STATUS'] === 0 ? resolve(res) : reject(res);
      });
    });
  }
  getTaskPermission(taskId: number): any { // 获取用户权限
    return this.get('/tasks/' + taskId + '/permission', true);
  }
  claimIncidentTask(taskId: number): Promise<any> { // 事故认领
    return new Promise((resolve, reject) => {
      this.put(`/incidentTasks/${taskId}/assignToMyself`, null, true).subscribe(res => {
        res && res['STATUS'] === 0 ? resolve(res) : reject(res);
      });
    });
  }
  updateIncidentReporting(taskId: number, params: any): any {
    return this.put('/incident/report/' + taskId, params, true);
  }
  // gmp认领
  claimGmpTask(taskId: number): any {
    return this.put('/inspectionTasks/' + taskId + '/assignToMyself', null, true);
  }

  rejectGmpTask(data) {
    return this.post('/inspectionTasks/rejectTask', data, true);
  }

  getIncidentDiagnosticList(taskId: number): Promise<any> { // 讀取安排事故調查列表
    return new Promise((resolve, reject) => {
      this.get(`/incidentDiagnostic/assignInvestigationList/${taskId}`, true).subscribe(res => {
        res && res['STATUS'] === 0 ? resolve(res) : reject(res);
      });
    });
  }
  updateIncidentDiagnosticList(taskId: number, incidentDiagnosedList: any): Promise<any> { // 更新安排事故調查列表
    return new Promise((resolve, reject) => {
      this.post(`/incidentDiagnostic/${taskId}/list`, incidentDiagnosedList, true).subscribe(res => {
        res && res['STATUS'] === 0 ? resolve(res) : reject(res);
      });
    });
  }
  getInvolvedPeopleList(taskId: number): any { // 讀取事故當事人列表
    return this.get('/incidentInvolved/list/' + taskId, true);
  }
  submitIncidentDiagnostic(taskId: number): Promise<any> { // 送出
    return new Promise((resolve, reject) => {
      this.put(`/incidentTasks/${taskId}/submitDiagnostic`, null, true).subscribe(res => {
        res && res['STATUS'] === 0 ? resolve(res) : reject(res);
      });
    });
  }
  getRelativeTaskList(taskId: number): any { // 获取事故调查报告
    return this.get('/incidentTasks/' + taskId + '/relatedReport', true);
  }
  turnToSend(taskId: number, target: any): any { // 转派事故调查报告任务
    return this.put('/incidentTasks/' + taskId + '/reassign', target, true);
  }

  // =========================相关方接口============================
  // 相关方登录
  permissionsContractorLogin(userName: string, password: string, verificationCode: string, proof: string): any {
    // return this.post('/contractorPermissions/login', { userName, password, verificationCode, proof }, false);
    return this.post('/contractorPermissions/login', {
      thresholdSignature: userName,
      calibrationChecksum: password,
      verificationCode,
      proof,
      accessSource: 'app'
    }, false);
  }

  // 承包商公司-列表
  getContractorCompanyList(param): any {
    return this.post('/interestedParty/list', param, true);
  }

  // 变更承包商状态
  changeSupplierStatus(status, id) {
    return this.get('/interestedParty/updateStatus/' + status + '/' + id, true);
  }

  // 删除承包商列表
  deleteSupplier(ids): any {
    return this.delete('/interestedParty/' + ids, true);
  }

  //新增承包商主记录
  addSupplier(param): any {
    return this.post('/interestedParty', param, true);
  }

  //提交承包商主记录
  submitSupplier(param): any {
    return this.post('/interestedParty/sumbitInterestedParty', param, true);
  }

  // 编辑承包商主记录
  editSupplier(param): any {
    return this.put('/interestedParty', param, true);
  }

  // 获取指定id承包商信息
  getSupplier(id) {
    return this.get('/interestedParty/' + id, true);
  }

  // 获取项目合同列表
  loadProjectList(id): any {
    const queryUtils = {
      pagingTool: {
        currentPage: 1,
        pageSize: 1000,
      },
      params: {
        "interestedPartyId": id,
        "include": true
      }
    };
    return this.post('/interestedPartyProject/list', queryUtils, true);
  }

  // 获取考评记录列表
  loadAppraisalRecordList(id) {
    return this.get('/evaluation/getByInterestedPartyId/' + id, true);
  }

  // 获取合规文件列表
  getDocumentList(id) {
    return this.get('/interestedParty/list/compliantDocument/' + id, true);
  }

  // 获取合规文件详情
  getDocumentDetail(id) {
    return this.get('/interestedParty/' + id + '/compliantDocument', true);
  }

  // 新增合规文件
  addDocument(param): any {
    return this.post('/interestedParty/create/compliantDocument', param, true);
  }

  // 编辑合规文件
  editDocument(param): any {
    return this.post('/interestedParty/update/compliantDocument', param, true);
  }

  // 变更合规文件状态-设为无效
  changeDocumentStatus(id) {
    return this.get('/interestedParty/update/compliantDocumentStatus/' + id, true);
  }

  // 获取任务权限
  getPermission(id) {
    return this.get('/tasks/' + id + '/permission', true);
  }

  // 讀取基本資訊
  getBasicInfo(id) {
    return this.get('/tasks/' + id + '/basicInfo', true);
  }

  // 作业申请任务详情
  getGeneralWorkDetailInfo(id) {
    return this.get('/schoolAssignment/' + id, true);
  }

  // 获取危险作业列表
  loadWorkPermits(id) {
    return this.get('/schoolAssignment/specialType/getList/' + id, true);
  }

  // 作业前检查
  loadPreWorkCheckInfo(id) {
    return this.get('/tasks/getWorkChecking/' + id, true);
  }

  // 查询特种作业详情
  getSpecialWorkDetai(id) {
    return this.get('/schoolAssignment/specialType/' + id, true);
  }

  // 项目管理任务详情
  loadProjectDetail(id) {
    return this.get('/interestedPartyProject/' + id, true);
  }

  //获取项目合规文件列表
  loadProjectDocuments(id) {
    return this.get('/interestedPartyProject/list/relatedDocument/' + id, true);
  }

  // 承包商任务详情
  loadContractorDetail(id) {
    return this.get('/interestedParty/' + id, true);
  }

  // 获取承包商证件列表
  loadContractorDocuments(id) {
    return this.get('/interestedParty/list/compliantDocument/' + id + '/review', true);
  }

  // 承包商人员任务详情
  loadEmployeeDetail(id) {
    return this.get('/employees/interestedParty/' + id, true);
  }

  // 获取承包商人员证件列表
  loadPersonnelDocuments(id) {
    return this.get('/interestedParty/list/qualificationDocument/' + id + '/review', true);
  }

  // 讀取詳細資訊
  getDetailInfo(id) {
    return this.get('/schoolAssignment/task/' + id, true);
  }

  // 讀取詳細資訊 - 批量人员审批
  getBatchEmployeesInfo(id) {
    return this.get('/workFlow/queryContractorBatchTask/BasicInfo/' + id, true);
  }

  // 承包商人员批量审批 - 主任务提交
  submitBatchEmployees(param): any {
    return this.post('/workFlow/taskReview/contractorEmployeeBatch', param, true);
  }

  // 获取可指派职称列表
  getAllocatedJobList(taskType, area, code) {
    return this.get('/workFlow/queryAllocatedJobTitle/' + taskType + '/' + area + '/' + code, true);
  }

  // 获取当前职称可指派人员
  getAllocatedEmployeeList(param): any {
    return this.post('/workFlow/queryAllocatedEmployee', param, true);
  }

  // 任务审批（通过/驳回）
  submitCorrectiveAction(param): any {
    return this.post('/workFlow/taskReview', param, true);
  }

  // 获取审批人及附件记录
  getApproverInfo(id) {
    return this.get('/workFlow/queryTaskInfo/' + id, true);
  }

  // 获取检查人信息
  getInspectorInfo(id) {
    return this.get('/workFlow/queryTaskInfo/workInspector/' + id, true);
  }

  // 通过任务id获取任务的执行人id
  getAssigneeUser(id) {
    return this.get('/tasks/getAssigneeUser/' + id, true);
  }

  // 获取作业审批，一次审批时的图片
  getFirstAttachments(id) {
    return this.get('/workFlow/getWorkFlowAttachments/' + id + '/first_review_briefingReocrd_attachment', true);
  }

  // 获取承包商人员列表
  getContractorEmployeeList(param): any {
    return this.post('/employees/interestedParty/list', param, true);
  }

  // 删除承包商人员
  deleteContractorEmployee(ids): any {
    return this.delete('/employees/interestedParty?id=' + ids.toString(), true);
  }

  // 批量提交承包商人员
  batchSubmitEmployees(param): any {
    return this.post('/employees/sumbitEmployee/batch', param, true);
  }

  // 变更承包商人员状态
  changeEmployeeStatus(status, id) {
    return this.get('/interestedParty/employee/updateStatus/' + status + '/' + id, true);
  }

  //新增员工主记录
  addEmployee(param): any {
    return this.post('/employees/interestedParty', param, true);
  }

  // 编辑员工主记录
  editEmployee(param): any {
    return this.put('/employees/interestedParty', param, true);
  }

  // 提交
  submitEmployee(param): any {
    return this.post('/employees/sumbitEmployee', param, true);
  }

  // 获取员工详情
  getEmployee(id) {
    return this.get('/employees/interestedParty/' + id, true);
  }

  // 变更资质证件状态
  changeEmployeeDocumentStatus(id) {
    return this.get('/interestedParty/update/qualificationDocumentStatus/' + id, true);
  }

  // 获取资质证件列表
  getCertificateList(id) {
    return this.get('/interestedParty/list/qualificationDocument/' + id, true);
  }

  // 获取资质证件详情
  getCertificateDetail(id) {
    return this.get('/interestedParty/' + id + '/qualificationDocument', true);
  }

  // 新增资质证件
  addCertificate(param): any {
    return this.post('/interestedParty/create/qualificationDocument', param, true);
  }

  // 编辑资质证件
  editCertificate(param): any {
    return this.post('/interestedParty/update/qualificationDocument', param, true);
  }

  // 删除资质证件
  deleteCertificate(ids): any {
    return this.delete('/interestedParty/delete/qualificationDocument/' + ids.toString(), true);
  }

  // 获取作业记录列表
  loadWorkRecordList(id) {
    return this.get('/schoolAssignment/getByUserId/' + id, true);
  }

  // 承包商列表
  getSupplierList(isProject?: boolean, orgId?: number): any {
    const queryUtil: any = {
      params: {},
      pagingTool: {
        currentPage: 1,
        pageSize: 20
      },
      queryCriterias: [],
      queryOrderBies: [{
        columnName: 'party.id',
        orderType: 'desc'
      }],
    };
    if (isProject) {
      queryUtil.params.status = '_STATUS_S1_1'
    }
    if (orgId) {
      queryUtil.params.orgIds = orgId
    }

    return this.post('/interestedParty/list', queryUtil, true);
  }

  // 承包商列表
  getSupplierListLazy(queryUtil): any {
    // const queryUtil: any = {
    //   params: {},
    //   pagingTool: {
    //     currentPage: 1,
    //     pageSize: 20
    //   },
    //   queryCriterias: [],
    //   queryOrderBies: [{
    //     columnName: 'party.id',
    //     orderType: 'desc'
    //   }],
    // };
    // if (isProject) {
    //   queryUtil.params.status = '_STATUS_S1_1'
    // }
    // if (orgId) {
    //   queryUtil.params.orgIds = orgId
    // }

    return this.post('/interestedParty/list', queryUtil, true);
  }  

  // 承包商所属项目
  getProjectList(contractorId): any {
    const queryUtil = {
      pagingTool: {
        currentPage: 1,
        pageSize: -1
      },
      queryCriterias: [],
      queryOrderBies: [{
        columnName: 'id',
        orderType: 'desc'
      }],
      params: {
        interestedPartyId: contractorId,
      }
    };
    return this.post('/interestedPartyProject/list', queryUtil, true);
  }

  // 获取项目列表
  getProjectListOfRecords(param): any {
    return this.post('/interestedPartyProject/list', param, true);
  }

  getCorpChildren(param): any {
    return this.post('/corporates/allChildren', param, true);
  }

  // 添加项目
  addProject(param): any {
    return this.post('/interestedPartyProject', param, true);
  }

  // 提交项目
  submitProject(param): any {
    return this.post('/interestedPartyProject/submit', param, true);
  }

  // 关闭项目
  closeProject(id) {
    return this.get('/interestedPartyProject/update/projectStatus/' + id, true);
  }

  // 编辑
  editProject(param): any {
    return this.put('/interestedPartyProject', param, true);
  }

  // 获取地点下拉
  getLocationList(orgId?, status?, keywords?): any {
    const queryUtil = {
      pagingTool: {
        currentPage: 1,
        pageSize: -1
      },
      queryCriterias: [],
      queryOrderBies: [{
        columnName: 'code',
        orderType: 'asc'
      }],
      params: {
        "orgId": orgId ? orgId : null,
      },
    };
    if (status) {
      queryUtil.queryCriterias.push(...([new QueryCriteria('es.status', '_SYS_A9_1', 'like')]));
    }
    queryUtil.queryCriterias.push(...([new QueryCriteria('space_name', keywords, 'like')]));
    return this.post('/space/tree/list/orgIds', queryUtil, true);
  }

  // 获取地点下拉
  getSpaceOfOrgId(orgId?, type?): any {
    if (orgId) {
      return this.get('/space/tree/' + (type ? type : '') + orgId, true);
    } else {
      return this.get('/space/tree', true);
    }
  }
  // 获取空间点协助人
  getGMPSpaceList(data): any {
    return this.post('/gmpSpace/list', data, true);
  }
   // 获取地点下拉
  getGmpSpaceOfOrgId(orgId?, type?): any {
    if (orgId) {
      return this.get('/gmpSpace/tree/' + (type ? type : '') + orgId, true);
    } else {
      return this.get('/gmpSpace/tree', true);
    }
  }
  // 获取地点下拉
  getLocationListNotTree(orgId?, status?, keywords?): any {
    const queryUtil = {
      pagingTool: {
        currentPage: 1,
        pageSize: -1
      },
      queryCriterias: [],
      queryOrderBies: [{
        columnName: 'code',
        orderType: 'asc'
      }],
      params: {
        "orgId": orgId ? orgId : null,
      },
    };
    if (status) {
      queryUtil.queryCriterias.push(...([new QueryCriteria('es.status', '_SYS_A9_1', 'like')]));
    }
    queryUtil.queryCriterias.push(...([new QueryCriteria('space_name', keywords, 'like')]));
    return this.post('/space/list/orgIds', queryUtil, true);
  }

  // 承包商列表
  supplierList(): any {
    const queryUtil = {
      pagingTool: {
        currentPage: 1,
        pageSize: -1
      },
      queryCriterias: [],
      queryOrderBies: [{
        columnName: 'party.id',
        orderType: 'desc'
      }],
      params: {
        // status: '_STATUS_S1_1',
      }
    };
    return this.post('/interestedParty/list', queryUtil, true);
  }

  // 承包商人员列表
  getEmployeeList(contractorId): any {
    const queryUtil = {
      pagingTool: {
        currentPage: 1,
        pageSize: -1
      },
      queryCriterias: [],
      queryOrderBies: [{
        columnName: 'party.id',
        orderType: 'desc'
      }],
      params: {
        interestedPartyId: contractorId,
        status: '_SYS_A9_1',
      }
    };
    return this.post('/employees/interestedParty/list', queryUtil, true);
  }

  // 删除合规文件
  deleteProject(ids): any {
    return this.delete('/interestedPartyProject/' + ids.toString(), true);
  }

  // 新增文件
  addDocumentProject(param): any {
    return this.post('/interestedPartyProject/create/relatedDocument', param, true);
  }

  // 获取文件详情
  getDocumentDetailProject(id) {
    return this.get('/interestedPartyProject/' + id + '/relatedDocument', true);
  }

  // 编辑文件
  editDocumentProject(param): any {
    return this.post('/interestedPartyProject/update/relatedDocument', param, true);
  }

  // 删除文件
  deleteDocumentProject(ids): any {
    return this.delete('/interestedPartyProject/delete/relatedDocument/' + ids.toString(), true);
  }

  //  承包商项目一键导出所有合规文件
  exportProjectComplianceFile(id) {
    console.log(id);
    return this.put('/interestedPartyProject/sendEmailFile/relatedDocument/' + id, null, true);
  }

  // 获取文件列表
  getDocumentListProject(id) {
    return this.get('/interestedPartyProject/list/relatedDocument/' + id, true);
  }

  // 获取作业记录列表
  loadWorkRecordListProject(id) {
    return this.get('/schoolAssignment/getByProjectId/' + id, true);
  }

  // 获取考评记录列表
  loadAppraisalRecordListProject(id) {
    return this.get('/evaluation/getByProjectId/' + id, true);
  }

  // 获取作业PDF
  getWorkPdf(taskId, content): any {
    const url = this.urlPrefix + '/schoolAssignment/' + taskId + '/print/pdf';
    const newHeader = new HttpHeaders({
      'token': this.localStorageService.getStore('token'),
      'Content-Type': 'application/xml',
    });
    return this.http.post(url, content, { headers: newHeader })
      .timeout(TIME_OUT)
      .catch((err: Response) => {
        // if (err.status == 401 || err.status === undefined) {
        //   this.localStorageService.removeStore('token')
        //   const isContractor: boolean = localStorage.getItem('partyEmployee') === 'true' ? true : false ;
        //   if (isContractor) {
        //     this.router.navigate(['/login/contractor-login']);
        //   } else {
        //     this.router.navigate(['/login']);
        //   }
        // }
        return Observable.throw(new Error(err ? err.toString() : 'Unknown Error'));
      })
  }

  // 删除作业人员
  deleteWork(ids): any {
    return this.delete('/schoolAssignment/' + ids.toString(), true);
  }

  // 变更作业状态
  changeWorkStatus(data) {
    return this.get('/interestedParty/employee/updateStatus/' + data.status + '/' + data.id, true);
  }

  // 获取作业列表
  getWorkList(param): any {
    return this.post('/schoolAssignment/list', param, true);
  }

  // 关闭作业
  closeWork(id): any {
    const newHeader = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.post('/schoolAssignment/close/' + id, { headers: newHeader }, true);
  }

  // 暂停作业
  pauseWork(id): any {
    const newHeader = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.post('/schoolAssignment/pause/' + id, { headers: newHeader }, true);
  }
  // 恢复作业
  resumeWork(id): any {
    const newHeader = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.post('/schoolAssignment/resume/' + id, { headers: newHeader }, true);
  }

  // 提交作业
  submitWork(param): any {
    return this.post('/workFlow/generateTask', param, true);
  }

  // 关闭泰国承包商作业
  closeThailandWork(param): any {
    return this.post('/schoolAssignment/close/generateTask', param, true);
  }

  // 关闭泰国承包商作业
  workFinishThailandWork(id): any {
    return this.get('/schoolAssignment/workFinishConfirmation/' + id, true);
  }


  // 新增作业
  addWork(param): any {
    return this.post('/schoolAssignment', param, true);
  }

  // 编辑作业
  editWork(param): any {
    return this.put('/schoolAssignment', param, true);
  }

  // 查询作业
  getWork(id) {
    return this.get('/schoolAssignment/' + id, true);
  }

  // 获取作业列表
  setProjectObserver(taskId, array): any {
    return this.put('/interestedPartyProject/projectObserver/' + taskId, array, true);
  }

  // 地点列表
  locationsList(): any {
    const queryUtil = {
      pagingTool: {
        currentPage: 1,
        pageSize: -1
      },
      queryCriterias: [],
      queryOrderBies: [{
        columnName: 'id',
        orderType: 'desc'
      }],
      params: {}
    };
    return this.post('/space/list', queryUtil, true);
  }

  // 地点列表
  locationsListOfId(orgId): any {
    const queryUtil = {
      pagingTool: {
        currentPage: 1,
        pageSize: -1
      },
      queryCriterias: [],
      queryOrderBies: [{
        columnName: 'id',
        orderType: 'desc'
      }],
      params: {
        orgId: orgId
      }
    };
    return this.post('/space/list', queryUtil, true);
  }

  // 地点列表
  locationsListOfOrgIds(orgId): any {
    const queryUtil = {
      pagingTool: {
        currentPage: 1,
        pageSize: -1
      },
      queryCriterias: [],
      queryOrderBies: [{
        columnName: 'id',
        orderType: 'desc'
      }],
      params: {
        orgId: orgId
      }
    };
    return this.post('/space/list/orgIds', queryUtil, true);
  }

  // 承包商人员列表
  getEmployeeListOfId(contractorId): any {
    const queryUtil = {
      pagingTool: {
        currentPage: 1,
        pageSize: -1
      },
      queryCriterias: [],
      queryOrderBies: [{
        columnName: 'party.id',
        orderType: 'desc'
      }],
      params: {
        interestedPartyId: contractorId,
        status: '_SYS_A9_1'
      }
    };
    return this.post('/employees/interestedParty/list', queryUtil, true);
  }

  // 承包商人员轻量列表（下拉选择用，只返回 id/code/firstName/lastName/full_name）
  getEmployeeListMinOfId(contractorId): any {
    const queryUtil = {
      pagingTool: {
        currentPage: 1,
        pageSize: -1
      },
      queryCriterias: [],
      queryOrderBies: [{
        columnName: 'emp.id',
        orderType: 'desc'
      }],
      params: {
        interestedPartyId: contractorId,
        status: '_SYS_A9_1'
      }
    };
    return this.post('/employees/interestedParty/listMin', queryUtil, true);
  }

  // 获取承包商人员列表
  getContractorEmployeeListOfStatus(status): any {
    const queryUtil = {
      pagingTool: {
        currentPage: 1,
        pageSize: -1
      },
      queryOrderBies: [{
        columnName: 'id',
        orderType: 'asc'
      }],
      params: {
        selectPart: true,
        status: status,
      }
    };
    return this.post('/employees/interestedParty/list', queryUtil, true);
  }

  // 获取所有的承包商项目
  getProjectListOfAll(): any {
    const queryUtil = {
      pagingTool: {
        currentPage: 1,
        pageSize: -1
      },
      queryCriterias: [],
      queryOrderBies: [{
        columnName: 'id',
        orderType: 'desc'
      }],
    };
    return this.post('/interestedPartyProject/list', queryUtil, true);
  }

  // 获取危险作业列表
  getWorkPermitList(id) {
    return this.get('/schoolAssignment/specialType/getList/' + id, true);
  }

  // 新增合规文件
  addWorkPermit(param): any {
    return this.post('/schoolAssignment/specialType', param, true);
  }

  // 修改合规文件
  editWorkPermit(param): any {
    return this.put('/schoolAssignment/specialType', param, true);
  }

  // 获取合规文件详情
  getWorkPermitDetail(id) {
    return this.get('/schoolAssignment/specialType/' + id, true);
  }

  // 获取审批记录
  getApprovalRecordList(id) {
    return this.get('/schoolAssignment/approveTask/getList/' + id, true);
  }

  // 获取承包商公司、人员、项目审批记录
  getContractorApprovalRecordList(data) {
    return this.post('/workFlow/queryTaskInfo', data, true);
  }

  // 获取检查记录
  getInspectionRecordList(id) {
    return this.get('/schoolAssignment/inspectionTask/getList/' + id, true);
  }

  // 获取检查记录
  getSupplierPerson(type, taskId) {
    return this.get('/workFlowActivity/contractorApplicantInfo/imInspection/' + type + '/' + taskId, true);
  }

  // 新增作业立即检查
  addAdHocInspection(param): any {
    return this.post('/workFlowActivity/submit/app', param, true);
  }

  // 获取检查记录
  getInspectionResults(id) {
    return this.get('/inspectionTasks/' + id + '/inspectionObjectSummary', true);
  }


  getInspectionFormList(id) {
    return this.get('/inspectionTasks/' + id + '/formList', true);
  }

  // 获取检查记录
  getRelatedTasks(id) {
    return this.get('/inspectionTasks/' + id + '/relatedCATask', true);
  }

  // 获取立即检查复审权限
  getClaimPermission(id) {
    return this.get('/inspectionTasks/' + id + '/claimable', true);
  }

  // 取得巡查（讀取inspectionFormList）
  getInspection(id) {
    return this.get('/inspectionTasks/' + id + '/adHocInspection', true);
  }

  // 讀取詳細資訊
  getInspectionDetailInfo(id) {
    return this.get('/inspectionTasks/' + id + '/detailedInfo', true);
  }

  // 讀取詳細資訊
  getScheduledDetailInfo(id) {
    return this.get('/inspectionTasks/' + id + '/scheduled/detailedInfo', true);
  }

  // 讀取任務內容：隱患+整改
  getTaskContent(id) {
    return this.get('/inspectionTasks/' + id + '/deviations', true);
  }

  // 获取整改-承包商员工的组织架构和人员信息
  getTaskContentOfId(id) {
    return this.get('/workFlowActivity/contractorApplicantInfo/' + id, true);
  }

  // 保存巡查（更新巡查表格列表inspectionFormList）
  editInspectionFormList(id, inspectionFormList): any {
    return this.put('/inspectionTasks/' + id + '/inspectionForms', inspectionFormList, true);
  }

  // 送出任務
  submitTask(id): any {
    return this.post('/inspectionTasks/interestedPart/' + id + '/submit', null, true);
  }

  // 计划检查复审上传整改方案
  updatedAttachments(data): any {
    return this.post('/workFlowActivity/upload/attachments', data, true);
  }

  // 变更数据状态
  changeEvaluationRecordsStatus(data) {
    return this.get('/interestedParty/employee/updateStatus/' + data.status + '/' + data.id, true);
  }

  // 获取列表
  getEvaluationRecordsList(data): any {
    return this.post('/evaluation/list', data, true);
  }

  // 提交数据
  submitEvaluationRecords(data): any {
    return this.post('/evaluation/submit', data, true);
  }

  // 新增数据
  addEvaluationRecords(data): any {
    return this.post('/evaluation/save', data, true);
  }

  // 删除数据人员
  deleteEvaluationRecords(ids): any {
    return this.delete('/evaluation/records/' + ids.toString(), true);
  }

  // 编辑数据
  editEvaluationRecords(data): any {
    return this.post('/evaluation/save', data, true);
  }

  // 查询数据
  getEvaluationRecords(id) {
    return this.get('/evaluation/formInfo/' + id, true);
  }

  // 获取检查表详情
  getFormPreview(id) {
    return this.get('/forms/' + id + '/preview', true);
  }

  //提交BBSO
  addBBSO(params): any {
    return this.post('/BBSO/scheduleInspectionForms', params, true)
  }

  // 获取BBSO检查list
  getBBSOList(params): any {
    return this.post('/BBSO/correctiveActions/list', params, true);
  }

  // 提交计划观察
  submitPlanObserve(id): any {
    return this.post('/inspectionTasks/bbso/' + id + '/submit', null, true);
  }

  // bbso详情
  getBBSODeviationDetailByTaskId(id): any {
    return this.get('/BBSO/deviation/' + id, true);
  }
//bbso列表草稿删除
  deleteBBSODraftRecord(id): any {
    return this.delete('/BBSO/record/' + id, true);
  }
  // 获取帮助文档列表
  getSupportDocList(params: any): any {
    return this.post('/help/fileInfo/list', params, true);
  }

  // 新增帮助文档
  addFileInfo(params: any): any {
    return this.post('/help/fileInfo', params, true);
  }

  // 获取帮助文档
  getFileInfo(id: any): any {
    return this.get('/help/fileInfo/' + id, true);
  }

  // 更新帮助文档
  updateFileInfo(params: any): any {
    return this.put('/help/fileInfo', params, true);
  }

  // 删除帮助文档
  deleteFileInfo(id: any): any {
    return this.delete('/help/fileInfo/' + id, true);
  }

  // 提交反馈
  submitFeedback(params: any): any {
    return this.post('/feedBack', params, true);
  }

  // 报表------------------------------------------------

  // 相关方报表........
  // 1.有效与待审批承包商公司数量统计
  getCompanyNum(params: any): any {
    return this.post('/reportForms/contractor/companyNum', params, true);
  }


  // 2.承包商项目人员数量统计
  getEmployeeNumInProject(params: any): any {
    return this.post('/reportForms/contractor/employeeNumInProject', params, true);
  }

  // 3.承包商作业潜在危害因素统计
  getPotentialHazards(params: any): any {
    return this.post('/reportForms/contractor/potentialHazards', params, true);
  }

  // 4.承包商项目状态统计
  getProjectStatus(params: any): any {
    return this.post('/reportForms/contractor/projectStatus', params, true);
  }

  // 5.承包商作业状态统计
  getSchoolAssignmentStatus(params: any): any {
    return this.post('/reportForms/contractor/schoolAssignmentStatus', params, true);
  }

  // 6.承包商任务状态统计
  getTaskStatus(params: any): any {
    return this.post('/reportForms/contractor/taskStatus', params, true);
  }

  // 7.承包商已关闭项目统计
  getCloseProjectNum(params: any): any {
    return this.post('/reportForms/contractor/closeProjectNum', params, true);
  }

  // 8.承包商已结案作业整改措施统计
  getCloseSchoolAssignment(params: any): any {
    return this.post('/reportForms/contractor/closeSchoolAssignment', params, true);
  }

  // 9.承包商已结案作业整改措施统计
  getSchoolAssignmentSpace(params: any): any {
    return this.post('/reportForms/contractor/schoolAssignmentSpace', params, true);
  }

  // 10.承包商任务类型统计
  getTaskTypeNum(params: any): any {
    return this.post('/reportForms/contractor/taskTypeNum', params, true);
  }

  // 11.承包商发现数量统计
  getContractorFindingNum(params: any): any {
    return this.post('/reportForms/contractor/contractorFindingNum', params, true);
  }

  // 12.承包商项目作业类型统计
  getSchoolAssignmentNum(params: any): any {
    return this.post('/reportForms/contractor/schoolAssignmentNum', params, true);
  }

  // 13.当日承包商人员入场作业统计
  getEmployeeSchoolAssignment(params: any): any {
    return this.post('/reportForms/contractor/employeeSchoolAssignment', params, true);
  }

  // 风险报表........
  // 1.风险评估数量统计
  getAssessmentNum(params: any): any {
    return this.post('/reportForms/risk/assessmentNum', params, true);
  }
  // 2.风险管控措施数量统计
  getMeasuresNum(params: any): any {
    return this.post('/reportForms/risk/measuresNum', params, true);
  }
  // 3.风险管控措施状态统计
  getMeasuresStatusNum(params: any): any {
    return this.post('/reportForms/risk/measuresStatusNum', params, true);
  }
  // 4.工作危害分析风险点风险等级统计
  getPointRiskLevelNum(params: any): any {
    return this.post('/reportForms/risk/pointRiskLevelNum', params, true);
  }

  // 事故报表........
  // 1.事故分类统计
  getHazardCategory(params: any): any {
    return this.post('/reportForms/incident/categoryNum', params, true);
  }

  // 2.车辆事故潜在主要原因统计
  getVehicleAccidentCause(params: any): any {
    return this.post('/reportForms/incident/carCategoryNum', params, true);
  }

  // 3.事故地点范围和类别统计
  getLocationRangeAndCategory(params: any): any {
    return this.post('/reportForms/incident/incidentNum', params, true);
  }

  // 4.事故整改措施状态统计
  getCorrectiveMeasuresStatus(params: any): any {
    return this.post('/reportForms/incident/correctiveActionStatusNum', params, true);
  }

  // 5.事故类别统计
  getAccidentCategory(params: any): any {
    return this.post('/reportForms/incident/allCategoryNum', params, true);
  }

  // 6.事故已结案整改措施统计
  getResolutionAndRemedialMeasures(params: any): any {
    return this.post('/reportForms/incident/closedCorrectiveActionStatusNum', params, true);
  }

  // 7.事故供应链环节统计
  getSupplyChainSegment(params: any): any {
    return this.post('/reportForms/incident/supplyIncidentNum', params, true);
  }

  // 8.事故致死数量统计
  getFatalitiesCausedByAccidents(params: any): any {
    return this.post('/reportForms/incident/fatalitiesIncidentNum', params, true);
  }

  // 9.事故受伤数量统计
  getInjuredPeopleInAccidents(params: any): any {
    return this.post('/reportForms/incident/injuryStatisticsNum', params, true);
  }

  // 10.碰撞事故分类统计
  getCollisionAccidents(params: any): any {
    return this.post('/reportForms/incident/innerOutCarIncidentNum', params, true);
  }

  // 检查报表........
  // 1.计划检查任务状态统计
  getIssueStatusStatistics(params: any): any {
    return this.post('/reportForms/inspection/statusStatistics', params, true);
  }
  // 2.检查任务状态统计
  getIssueStatusAllStatistics(params: any): any {
    return this.post('/reportForms/inspection/statusAllStatistics', params, true);
  }
  // 3.检查发现数量统计
  getIssueDeviationNum(params: any): any {
    return this.post('/reportForms/inspection/deviationNum', params, true);
  }
  // 4.检查整改措施状态统计
  getIssueCorStatus(params: any): any {
    return this.post('/reportForms/inspection/corStatus', params, true);
  }
  // 5.检查已结案整改措施统计
  getIssueRectifyNum(params: any): any {
    return this.post('/reportForms/inspection/corCloseNum', params, true);
  }

  // 审核报表........
  // 1.审核整改措施状态统计
  getRectificationMeasuresStatus(params: any): any {
    return this.post('/reportForms/incident/correctiveActionStatusNum', params, true);
  }
  // 2.审核已结案整改措施完成时间统计
  getMeasuresCompletionTime(params: any): any {
    return this.post('/reportForms/incident/allCategoryNum', params, true);
  }
  // 3.审核发现项完成数量统计
  getCompletionQuantityOfFindings(params: any): any {
    return this.post('/reportForms/incident/allCategoryNum', params, true);
  }

  // BBSO报表........
  // 1.计划BBS观察任务状态统计
  getPlanBBSOTaskStatus(params: any): any {
    return this.post('/reportForms/bbso/statusStatistics', params, true);
  }
  // 2.BBS观察任务类型统计
  getBBSOTaskTypes(params: any): any {
    return this.post('/reportForms/bbso/typeStatistics', params, true);
  }
  // 3.BBS观察整改措施状态统计
  getBBSORectificationStatus(params: any): any {
    return this.post('/reportForms/bbso/measures/statusStatistics', params, true);
  }
  // 4.BBS观察已结案整改措施统计
  getClosedBBSORectification(params: any): any {
    return this.post('/reportForms/bbso/measures/num', params, true);
  }

  // app检查版本更新
  checkForUpdate(currentVersion: string, currentPlatform: string): any {
    return this.get(`/version/app/${currentPlatform}/${currentVersion}`, true);
  }

  // 承包商人员没有在任何地方被用到，则允许被删除。
  isDeleteEmployee(ids: string) {
    return this.get('/employees/interestedParty/acceptDeleteParty/' + ids.toString(), true);
  }


  // GMP审核发现完成情况统计
  getGmpFindingNum(queryUtil) {
    return this.post('/reportForms/gmp/findingNum', queryUtil, true);
  }

  // GMP审核评估得分率统计
  getGmpScore(queryUtil) {
    return this.post('/reportForms/gmp/score', queryUtil, true);
  }

  // GMP审核任务状态统计
  getGmpTaskStatusNum(queryUtil) {
    return this.post('/reportForms/gmp/taskStatusNum', queryUtil, true);
  }

  // GMP审核发现任务状态统计
  getGmpFindingTaskStatusNum(queryUtil) {
    return this.post('/reportForms/gmp/findingTaskStatusNum', queryUtil, true);
  }

  // GMP审核整改措施状态统计
  getGmpCorrectiveActionTaskStatusNum(queryUtil) {
    return this.post('/reportForms/gmp/correctiveActionTaskStatusNum', queryUtil, true);
  }

  // GMP审核发现分类统计
  getGmpFindingClassificationNum(queryUtil) {
    return this.post('/reportForms/gmp/findingClassificationNum', queryUtil, true);
  }

  // 当日是否在进行作业
  saveTableRelation(foreighValue: number, linkKey: number) {
    const para = {
      linkKey: linkKey,
      foreighValue: foreighValue,
      linkType: "_SYS_WH_7_IPA",
    };
    return this.put('/workFlow/saveTableRelation', para, true);
  }

  // 当日是否在进行作业
  saveTableRelationList(data) {
    return this.put('/workFlow/saveTableRelationList', data, true);
  }

  // 当日是否在进行作业回显
  workRelation(id) {
    return this.get('/workFlow/getLinkValue/' + id + '/_SYS_WH_7_IPA', true);
  }

  // 当日是否在进行作业回显
  workRelationList(id) {
    return this.get('/workFlow/getLinkValue/' + id + '/_SYS_WH_8_IPA', true);
  }  

  // 轉派
  assignTask(taskId: number, employeeId: number, orgId: number) {
    const para = {
      taskId: taskId,
      employeeId: employeeId,
      orgId: orgId
    };
    return this.put('/workFlow/transfer', para, true);
  }
  // 轉派权限
  getLinkValue(id) {
    return this.get('/workFlow/getLinkValue/' + id + '/_SYS_WH_7_SC', true);
  }

  getRiskMapList(queryUtil) {
    return this.post('/planarMap/data', queryUtil, true);
  }

  getRiskHKMapList(queryUtil) {
    return this.post('/planarMap/special/data', queryUtil, true);
  }

  // 获取当前用户角色等级
  getCheckRoleLeve(menuCode: string) {
    return this.get('/roles/checkRoleLevel?menuCode=' + menuCode, true);
  }

  // gmp 平面图列表
  gmpDrawingManagementList(queryUtil):any {
    return this.post('/gmpDrawingManagement/list', queryUtil, true);
  }

   // gmp 获取当前平面图
  getGmpFloorPlanImg(id: string):any {
    return this.get('/gmpDrawingManagement/'+ id, true);
  }

  queryInspectionList(data): any{
    // const data = {
    //   pagingTool: {currentPage: 1, pageSize: -1},
    //   queryCriterias: []
    // }

    // if (drawing) {
    //   data.queryCriterias.push({
    //     "connection": "and",
    //     "key": "drawingId",
    //     "condition": "=",
    //     "value": drawing.id,
    //     "isValueADigital": false
    //   })
    // }
    return this.post('/inspectionTasks/drawing/list', data, true);
  }  
    // 延期
  delayGmpTask(param): any {
    return this.put('/inspectionTasks/extension/china', param, true);
  }
  // 保存
  updateGmp(data):any {
    return this.post('/GmpInspections/update/GMP', data, true);
  }

  // 延期驳回
  rejectExtension(data): any {
    return this.post('/inspectionTasks/rejectTask/china', data,true);
  }

  // 获取空间点协助人
  getSpaceAssistantDTOs(id): any {
    return this.get('/gmpSpace/getRootSpace/' + id, true);
  }

    // gmp 检查 转派
  reassignGMPInspections(taskId, data): any {
    return this.put('/GmpInspections/' + taskId + '/reassign', data, true);
  }

  // 自定义检查 接口    ----------------------------------------开始
  getActivitiesDetail(id): any {
    return this.get('/gmp/activities/' + id, true);
  }

  checkQrcodeExpired(id): any{
    return this.get('/gmp/activities/getValidTime/' + id, true);
  }

  saveCustomGMPDraft(data: any): any {
    return this.post('/GmpInspections/save/custom/GMP', data,true);
  }

  submitCustomGMPDraft(data: any): any {
    return this.post('/GmpInspections/submit/custom/GMP', data,true);
  }

  // 删除检查记录
  deleteInspectionTask(id): any {
    return this.delete('/inspectionTasks/taskIds/' + id, true);
  }

  // 删除GMP发现项（含整改措施）
  deleteGmpFinding(taskId: number): any {
    return this.post('/inspectionTasks/gmpFindings/delete', { taskIds: [taskId] }, true);
  }

  // ============================================================
  // CAPA Management
  // ============================================================

  capaSaveDraft(payload: any): any {
    return this.post('/capa/audit/draft', payload, true);
  }

  capaSubmit(payload: any): any {
    return this.post('/capa/audit', payload, true);
  }

  capaGetDraft(id: number | string): any {
    return this.get('/capa/audit/draft/' + id, true);
  }

  getTaskBasicInfo(id: number | string): any {
    return this.get('/tasks/' + id + '/basicInfo', true);
  }

  capaGetFindingTasks(id: number | string): any {
    return this.get('/capa/audit/' + id + '/findingTask', true);
  }

  capaFindingMainTask(id: number | string): any {
    return this.get('/capa/finding/' + id + '/mainTask', true);
  }

  capaClose(id: number | string, desc: string): any {
    return this.post('/capa/audit/' + id + '/close', { desc: desc }, true);
  }

  capaSourceList(orgId: number | string): any {
    return this.post('/capaSource/validList', {
      pagingTool: { currentPage: 1, pageSize: -1 },
      queryOrderBies: [{ columnName: 'id', orderType: 'desc' }],
      queryCriterias: [],
      params: { perOrgId: orgId },
    }, true);
  }

  capaRecordList(query: any): any {
    return this.post('/capa/list', buildCapaRecordQuery(query, this.pageSize), true);
  }

  deleteCapaRecord(taskId: number | string): any{
    return this.post('/capa/delete', { taskId }, true);
  }

  previewDeleteFinding(taskId: number | string): any {
    return this.post('/capa/finding/delete/preview', { taskId }, true);
  }

  deleteFinding(taskId: number | string, expectedDeleteMode: 'FINDING_ONLY' | 'CASCADE_CAPA'): any {
    return this.post('/capa/finding/delete', { taskId, expectedDeleteMode }, true);
  }

  findingsRecordList(query: any): any {
    return this.post('/capa/finding/list', buildFindingsRecordQuery(query, this.pageSize), true);
  }

  findingRecordGet(id: number | string): any {
    return this.get('/capa/finding/' + id, true);
  }

  findingRejectReason(id: number | string): any {
    return this.get('/capa/finding/' + id + '/rejectReason', true);
  }

  correctiveActionVerification(id: number | string): any {
    return this.get('/capa/correctiveAction/' + id + '/verification', true);
  }

  correctiveActionReview(id: number | string): any {
    return this.get('/capa/correctiveAction/' + id + '/review', true);
  }

  capaSaveCorrectiveAction(payload: any): any {
    return this.post('/capa/correctiveAction', payload, true);
  }

  capaSubmitCorrectiveAction(id: number | string): any {
    return this.post('/capa/correctiveAction/' + id + '/submit', {}, true);
  }

  correctiveActionApprove(id: number | string, desc?: string): any {
    return this.post('/capa/correctiveAction/' + id + '/approve', { desc: desc || '' }, true);
  }

  correctiveActionVerificationReject(id: number | string, rejectReason: string): any {
    return this.post('/capa/correctiveAction/' + id + '/verification/reject',
      { rejectReason: rejectReason }, true);
  }

  correctiveActionReject(id: number | string, rejectReason: string): any {
    return this.post('/capa/correctiveAction/' + id + '/reject',
      { desc: rejectReason }, true);
  }

  correctiveActionVerificationApprove(id: number | string, desc: string): any {
    return this.post('/capa/correctiveAction/' + id + '/verification/approve',
      { desc: desc }, true);
  }

  getCapaExecutionContent(investigationId: number | string): any {
    return this.get('/tasks/correctiveAction/corrective/' + investigationId + '/content', true);
  }

  saveExecutionContent(payload: any): any {
    return this.put('/tasks/correctiveAction/inspectionContent', payload, true);
  }

  capaCompletionSubmit(id: number | string): any {
    return this.post('/capa/correctiveAction/' + id + '/completion/submit', {}, true);
  }

  // 扫码权限校验：检查当前用户是否有访问指定组织的权限
  checkIsOrgPermission(orgId: number): any {
    return this.get(`/corporates/checkRequest/${orgId}`, true);
  }
}
